/**
 * Changelog — hardcoded Einträge (siehe lib/changelog.ts), im Theme der
 * Ticket-Liste/-Detailseiten. Einträge als Badge-Zeilen untereinander,
 * Klick klappt die Details auf. Öffnen der Seite markiert alles als gelesen.
 */

import { useEffect, useState } from 'react';
import { ChevronDown, Megaphone } from 'lucide-react';
import { CHANGELOG, markChangelogSeen, type ChangelogType } from '@/lib/changelog';

const TYPE_LABELS: Record<ChangelogType, string> = {
  NEU: 'Neu',
  UPDATE: 'Update',
  FIX: 'Fix',
  WICHTIG: 'Wichtig',
};

const Changelog = () => {
  const [openId, setOpenId] = useState<string | null>(CHANGELOG[0]?.id ?? null);

  // Seite geöffnet → alles gelesen; Sidebar-Badge erlischt sofort (Event).
  useEffect(() => {
    markChangelogSeen();
  }, []);

  return (
    <div className="ticket-list-shell changelog-shell h-full flex flex-col">
      <div className="ticket-list-page-header">
        <div>
          <span className="ticket-list-eyebrow">Vyndesk</span>
          <div className="flex items-center gap-2.5">
            <h1 className="ticket-list-title">Changelog</h1>
            <span className="ticket-list-total">{CHANGELOG.length}</span>
          </div>
          <p className="ticket-list-description">
            Alle Updates und Verbesserungen — der neueste Eintrag steht oben.
          </p>
        </div>
        <div className="changelog-header-icon" aria-hidden="true">
          <Megaphone className="h-4 w-4" />
        </div>
      </div>

      <div className="changelog-list">
        {CHANGELOG.map((entry) => {
          const open = openId === entry.id;
          return (
            <div key={entry.id} className={`changelog-entry${open ? ' is-open' : ''}`}>
              <button
                type="button"
                className="changelog-entry-row"
                onClick={() => setOpenId(open ? null : entry.id)}
                aria-expanded={open}
              >
                <span className={`changelog-badge changelog-badge--${entry.type.toLowerCase()}`}>
                  {TYPE_LABELS[entry.type]}
                </span>
                <span className="changelog-entry-title">{entry.title}</span>
                <span className="changelog-entry-date">{entry.date}</span>
                <ChevronDown className={`changelog-entry-chevron${open ? ' is-open' : ''}`} />
              </button>
              {open && (
                <div className="changelog-entry-body">
                  <p className="changelog-entry-summary">{entry.summary}</p>
                  {/* Hardcoded, eigener Inhalt — bewusst ohne Sanitizer gerendert */}
                  <div
                    className="changelog-entry-html"
                    dangerouslySetInnerHTML={{ __html: entry.html }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Changelog;
